import { Box, CircularProgress, Typography } from '@mui/material';
import useTenant from '../hooks/useTenant';

function BrandedLoader() {
  const { branding, currentTenant } = useTenant();
  const logoUrl =
    branding?.logoUrl ||
    branding?.logoInvertidoUrl ||
    currentTenant?.logoUrl ||
    currentTenant?.logoInvertidoUrl ||
    null;
  const nome = branding?.nome || currentTenant?.nome || null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
        gap: 3,
        bgcolor: 'background.default',
        px: 3,
      }}
    >
      {logoUrl ? (
        <Box
          component="img"
          src={logoUrl}
          alt={nome || 'Logo'}
          sx={{ maxWidth: 220, maxHeight: 96, objectFit: 'contain' }}
        />
      ) : nome ? (
        <Typography variant="h4" fontWeight={700} color="text.primary">
          {nome}
        </Typography>
      ) : null}

      <CircularProgress size={28} sx={{ color: 'text.disabled' }} />
    </Box>
  );
}

export default BrandedLoader;
